var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0003 147.333C33.3337 147.333 0.666992 114.667 0.666992 73.9998C0.666992 33.3332 33.3337 0.666504 74.0003 0.666504C114.667 0.666504 147.334 33.3332 147.334 73.9998C147.334 114.667 114.667 147.333 74.0003 147.333ZM74.0003 13.9998C40.667 13.9998 14.0003 40.6665 14.0003 73.9998C14.0003 107.333 40.667 134 74.0003 134C107.334 134 134 107.333 134 73.9998C134 40.6665 107.334 13.9998 74.0003 13.9998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.001 110.666C102.001 110.666 100.667 110 99.334 108.666L39.334 48.6663C36.6673 45.9997 36.6673 41.9997 39.334 39.333C42.0007 36.6663 46.0006 36.6663 48.6673 39.333L108.667 99.333C111.334 102 111.334 106 108.667 108.666C107.334 110 106.001 110.666 104.001 110.666Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.84741a92.svg";
export { ForwardRef as ReactComponent };